import { connect } from 'react-redux'
import Fuse from 'fuse.js'

import { setSearchResults, clearSearchResults } from '../../../reducers/searchReducer'
import SearchTerm from '../SearchTerm'

// Initialize Search Engine (Fuse)

// TODO: Move the following to static file called searchIndex.js created by build step!
import { gettingStartedSearchIndex } from '../../../constants/gettingStartedSearchIndex'
import { javascriptSdkSearchIndex } from '../../../constants/javascriptSdkSearchIndex'
// import { apiSearchIndex } from '../../../constants/apiSearchIndex';
import { widgetSearchIndex } from '../../../constants/widgetSearchIndex'
import { widgetStaticSearchIndex } from '../../../constants/widgetStaticSearchIndex'

// __APISEARCHINDEX__ is a global variable from the webpack config
// eslint-disable-next-line no-undef
const apiSearchIndex = __APISEARCHINDEX__

// Search API

const searchIndex = [
	...apiSearchIndex,
	...widgetStaticSearchIndex,
	...widgetSearchIndex,
	...gettingStartedSearchIndex,
	...javascriptSdkSearchIndex,
]

const options = {
	shouldSort: true,
	tokenize: true,
	matchAllTokens: true,
	threshold: 0.2,
	location: 0,
	distance: 100,
	maxPatternLength: 32,
	minMatchCharLength: 1,
	keys: ['title', 'summary', 'fields'],
}
const fuse = new Fuse(searchIndex, options)

// Redux generated Container Component

const mapStateToProps = (state, ownProps) => {
	return {
		searchTerm: state.search.searchTerm,
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onSearch: searchTerm => {
			// No search term
			if (!searchTerm) {
				dispatch(clearSearchResults())
				return
			}

			// Call fuse to evaluate
			const result = fuse.search(searchTerm)
			const resultLimit = 20

			// Break result into sections
			const api = result
				.filter(match => match.section === 'api')
				.slice(0, resultLimit)
				.map(match => {
					return { title: match.title, path: match.path }
				})
			const gettingStarted = result
				.filter(match => match.section === 'gettingStarted')
				.slice(0, resultLimit)
				.map(match => {
					return { title: match.title, path: match.path }
				})
			const javascriptSdk = result
				.filter(match => match.section === 'javascriptSdk')
				.slice(0, resultLimit)
				.map(match => {
					return { title: match.title, path: match.path }
				})
			const widgets = result
				.filter(match => match.section === 'widgets')
				.slice(0, resultLimit)
				.map(match => {
					return { title: match.title, path: match.path }
				})

			// Set state
			dispatch(
				setSearchResults({ searchTerm, result: { gettingStarted, api, javascriptSdk, widgets } })
			)
		},
	}
}

// <SearchTerm />
const SearchTermContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchTerm)

export default SearchTermContainer



// WEBPACK FOOTER //
// ./src/components/search/containers/SearchTermContainer.js